<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Közösség</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="user$ && userMetadata && discussions">


  <ion-card>
    <ion-card-header>
      <ion-card-title>Feed</ion-card-title>
      <ion-card-subtitle>Legújabb fórum bejegyzések</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <!--ion-list>
      <ion-item *ngFor="let d of discussions">
        <ion-thumbnail slot="start">
          <img alt="Silhouette of mountains" src="https://ionicframework.com/docs/img/demos/thumbnail.svg" />
        </ion-thumbnail>
        <ion-label>{{d.attributes.title}}</ion-label>
      </ion-item>

    </ion-list-->
      <div class="DiscussionList">
        <ul role="feed" class="DiscussionList-discussions">
          <li data-id="2" role="article" aria-setsize="-1" aria-posinset="1" *ngFor="let post of discussions"
            style="border-bottom: 1px solid;margin-top:5px;padding-bottom: 5px;">
            <div class="DiscussionListItem">
              <!--div class="ButtonGroup Dropdown dropdown DiscussionListItem-controls itemCount8"><button
                  class="Dropdown-toggle Button Button--icon Button--flat Slidable-underneath Slidable-underneath--right"
                  aria-haspopup="menu" aria-label="Beszélgetési műveletek legördülő menüje be/ki"
                  data-toggle="dropdown"><i aria-hidden="true" class="icon fas fa-ellipsis-v Button-icon"></i><span
                    class="Button-label"></span><i aria-hidden="true"
                    class="icon fas fa-caret-down Button-caret"></i></button>
                <ul class="Dropdown-menu dropdown-menu ">
                  <li class="item-subscription"><button class="hasIcon" type="button"><i aria-hidden="true"
                        class="icon far fa-star Button-icon"></i><span class="Button-label">Követés
                        leállítása</span></button></li>
                  <li class="Dropdown-separator"></li>
                  <li class="item-rename"><button class="hasIcon" type="button"><i aria-hidden="true"
                        class="icon fas fa-pencil-alt Button-icon"></i><span
                        class="Button-label">Átnevezés</span></button></li>
                  <li class="item-tags"><button class="hasIcon" type="button"><i aria-hidden="true"
                        class="icon fas fa-tag Button-icon"></i><span class="Button-label">Címkék
                        szerkesztése</span></button></li>
                  <li class="item-sticky"><button class="hasIcon" type="button"><i aria-hidden="true"
                        class="icon fas fa-thumbtack Button-icon"></i><span class="Button-label">Kitűzés</span></button>
                  </li>
                  <li class="item-lock"><button class="hasIcon" type="button"><i aria-hidden="true"
                        class="icon fas fa-lock Button-icon"></i><span class="Button-label">Lezárás</span></button></li>
                  <li class="Dropdown-separator"></li>
                  <li class="item-hide"><button class="hasIcon" type="button"><i aria-hidden="true"
                        class="icon far fa-trash-alt Button-icon"></i><span class="Button-label">Törlés</span></button>
                  </li>
                </ul>
              </div><span class="Slidable-underneath Slidable-underneath--left Slidable-underneath--elastic disabled"><i
                  aria-hidden="true" class="icon fas fa-check"></i></span-->
              <div class="DiscussionListItem-content Slidable-content read"><!--a class="DiscussionListItem-author"
                  href="/u/kzwviqjcrfnmvhye2havlvqg" title="" aria-label="blaha.peter indította 8 napja"
                  data-original-title="blaha.peter indította 8 napja"><span class="Avatar" loading="lazy"
                    style="--avatar-bg: #e5b0a0;">B</span></a-->
                <ion-avatar class=" DiscussionListItem-author" style="margin-top: 0">
                  <!--img *ngIf="user$.attributes?.picture" [src]="user$.attributes.picture" [alt]="userMetadata.viselt_ker" /-->
                  <img [src]="environment.avatars+'/api/?name=TESZT&rounded=true&size=50&background=random'">
                  <ion-badge *ngIf="post.attributes.subscription == 'follow'" color="primary"
                    style="position: absolute;left: 40px;"><ion-icon name="star"></ion-icon></ion-badge>
                </ion-avatar>
                <!--ul class="DiscussionListItem-badges badges">
                  <li class="item-subscription">
                    <div class="Badge Badge--following text-contrast--unchanged" title="" aria-label="Követve" style=""
                      data-original-title="Követve"><i aria-hidden="true" class="icon fas fa-star Badge-icon"></i></div>
                  </li>
                </ul--><a [routerLink]="['/m/post', post.attributes.slug]" class="DiscussionListItem-main">
                  <h2 class="DiscussionListItem-title">{{post.attributes.title}}</h2>
                  <ul class="DiscussionListItem-info">
                    <li class="item-tags">
                      <span *ngFor="let tag of post.relationships.tags.data">
                        <span *ngFor="let inc of included">
                        <ion-badge *ngIf="tag.id == inc.id && inc.type=='tags'" color="primary">{{inc.attributes.name}}</ion-badge>
                        </span>
                      </span>
                      <!--span class="TagsLabel"><span class="TagLabel  colored text-contrast--light"
                          style="--tag-bg: #888;"><span class="TagLabel-text"><span
                              class="TagLabel-name">Általános</span></span></span><span class="TagLabel " style=""><span
                            class="TagLabel-text"><span class="TagLabel-name">Betegség</span></span></span><span
                          class="TagLabel  TagLabel--child" style=""><span class="TagLabel-text"><span
                              class="TagLabel-name">első betegség</span></span></span></span-->
                    </li>
                    <li class="item-terminalPost"><span *ngFor="let inc of included"><span
                          *ngIf="inc.type=='users' && inc.id==post.relationships.user.data.id"> <span
                            class="username">{{inc.attributes.displayName}}</span> indította <time pubdate=""
                            datetime="2025-07-27T14:25:17+02:00" title="2025. július 27., vasárnap 14:25"
                            data-humantime="">({{moment(post.attributes.createdAt).format("YYYY.MM.DD.")}})</time></span></span>
                    </li>
                  </ul>
                </a><span class="DiscussionListItem-count"><span
                    aria-hidden="true">{{post.attributes.commentCount-1}}</span><span class="visually-hidden">0
                    válasz</span></span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </ion-card-content>
  </ion-card>






</ion-content>